<template>
  <div id="ly_itinerary">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="创建模板" @addFn="addTemplate">
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="editTemplate(row)">编辑</el-button>
            <el-dropdown @command="handleCommand($event, row)" style="margin-left: 10px;">
              <el-button type="text">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="enable" v-if="row.status === 2">启用</el-dropdown-item>
                <el-dropdown-item command="disable" v-else>停用</el-dropdown-item>
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'name'">
          <el-tag v-if="row.status === 1" size="small" type="success">启用</el-tag>
          <el-tag v-else type="info" size="small">停用</el-tag>
          <span style="margin-left: 8px;">{{ row.name }}</span>
        </template>
        <template v-else-if="item.prop === 'totalDays'">
          <span>{{ row.totalDays }}天</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] !== null && row[item.prop] !== undefined ? row[item.prop] : '-' }}</span>
        </template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "ly_itinerary",
  data() {
    return {
      customOptions: {
        url: "/api/v1/manage/travelItinerary",
        params: { page: 1, size: 20 },
        search: [
          { type: "input", field: "name", name: "模板名称", value: "" },
          {
            type: "select", field: "status", name: "状态", value: "",
            option: [{ label: "启用", value: 1 }, { label: "停用", value: 2 }]
          },
        ],
      },
      columns: [
        { prop: "name", label: "模板名称", minWidth: 200 },
        { prop: "totalDays", label: "行程天数", width: 100 },
        { prop: "nodeCount", label: "节点数", width: 80 },
        { prop: "description", label: "描述", minWidth: 200 },
      ],
    };
  },
  methods: {
    addTemplate() {
      this.$router.push({ path: '/ly_itineraryEdit' });
    },
    editTemplate(row) {
      this.$router.push({ path: '/ly_itineraryEdit', query: { id: row.id } });
    },
    handleCommand(command, row) {
      if (command === 'delete') {
        this.$confirm('删除后无法恢复，是否删除该行程模板？', '删除模板', {
          confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning'
        }).then(async () => {
          let { code } = await this.$axios.delete('/api/v1/manage/travelItinerary', { id: row.id });
          if (code === 1) { this.$message.success('删除成功'); this.$refs.customTable.listFn(); }
        }).catch(() => {});
      } else if (command === 'enable') {
        this.$axios.put('/api/v1/manage/travelItinerary/status', { id: row.id, status: 1 }).then(({ code }) => {
          if (code === 1) { this.$message.success('已启用'); this.$refs.customTable.listFn(); }
        });
      } else if (command === 'disable') {
        this.$axios.put('/api/v1/manage/travelItinerary/status', { id: row.id, status: 2 }).then(({ code }) => {
          if (code === 1) { this.$message.success('已停用'); this.$refs.customTable.listFn(); }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#ly_itinerary {
  .custom-action {
    display: flex; align-items: center;
    .el-button--text { padding: 0; color: #2B77FF; }
  }
}
</style>
